import { ReactNode } from 'react'

import { useProviderDetails } from '../../providers/ProviderDetails/ProviderDetails.provider'
import { MainView } from './Main.view'

const Main = ({
  usePaper,
  children,
}: {
  usePaper?: boolean
  children?: ReactNode
}) => {
  const {
    myProviderDetails,
    updateProviderOnlineStatus,
    getProviderOnlineStatus,
    createVacationMessage,
    removeVacationMessage,
  } = useProviderDetails()

  return (
    <MainView
      usePaper={usePaper}
      myProviderDetails={myProviderDetails}
      updateProviderOnlineStatus={updateProviderOnlineStatus}
      getProviderOnlineStatus={getProviderOnlineStatus}
      createVacationMessage={createVacationMessage}
      removeVacationMessage={removeVacationMessage}
    >
      {children}
    </MainView>
  )
}

export { Main }
